import React from "react";

import { indexAct } from "../api/indexAct";

import device from "../../functions/device";

import { Modal, Table, message } from "antd";

import { Helmet } from "react-helmet";

import "antd/es/table/style/css";

const columnTitles = {
  COMPANY_GE: "კომპანია",
  DESCRIPTION_GE: "აღწერა",
  COMPANY_EN: "Company",
  DESCRIPTION_EN: "Description",
};

export default class RenderProducts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      products: [],
      categoryName: "",
      categoryImage: "",
    };
  }

  componentDidMount() {
    console.log("renderProducts");
    console.log(this.props);

    indexAct(
      "GET_PRODUCTS",
      {
        NAME: this.props.match.params.name,
      },
      "/"
    ).then((data) => {
      if (data.code === 200) {
        this.setState((state) => {
          state.loading = false;
          state.categoryName = data.res.CATEGORY_NAME;
          state.categoryImage = data.res.CATEGORY_IMAGE;
          state.products = data.res.PRODUCTS;
          return state;
        });
      } else {
        message.error("პროდუქტი არ მოიძებნა!", 5);
        this.setState((state) => {
          state.loading = false;
          state.categoryName = "";
          state.categoryImage = "";
          state.products = [];
          return state;
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log("componentDidUpdate");
  }

  columns = () => {
    return [
      {
        title: "",
        dataIndex: "COMPANY_LOGO",
        width: 10,
        align: "center",
        render: (text, record) => {
          const image =
            record.COMPANY_LOGO.length > 5
              ? `${window.APP.MEDIA}products/${record.COMPANY_LOGO}`
              : `${window.APP.MEDIA}no-image.png`;
          return (
            <a href={record.WEB} target="_blank" rel="noopener noreferrer">
              <img alt="example" src={image} style={{ width: "100px" }} />
            </a>
          );
        },
      },
      {
        title: columnTitles["COMPANY_" + this.props.lang],
        dataIndex: "COMPANY",
        width: 300,
        render: (text, record) => (
          <a href={record.WEB} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        ),
      },
      {
        title: columnTitles["DESCRIPTION_" + this.props.lang],
        dataIndex: "DESCRIPTION",
        width: 300,
        render: (text) => text,
      },
    ];
  };

  render() {
    const { products, loading, categoryName, categoryImage } = this.state;
    const image =
      categoryImage.length > 5
        ? `${window.APP.MEDIA}categories/${categoryImage}`
        : `${window.APP.MEDIA}no-image.png`;
    return (
      <>
        <Helmet>
          <title>{categoryName}</title>
          <meta name="description" content={categoryName} />

          {/* <!-- Google / Search Engine Tags --> */}
          <meta itemprop="name" content={categoryName} />
          <meta itemprop="description" content={categoryName} />
          <meta itemprop="image" content={image} />

          {/* <!-- Facebook Meta Tags --> */}
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={categoryName} />
          <meta property="og:description" content={categoryName} />
          <meta property="og:image" content={image} />
        </Helmet>
        <Modal
          destroyOnClose
          title={categoryName}
          width={device().isMobile ? "100%" : "70%"}
          visible={true}
          onCancel={() => {
            this.props.history.replace("/#products");
          }}
          footer={null}
          centered
          bodyStyle={{ height: "600px", overflowY: "auto", padding: "5px 5px" }}
        >
          <Table
            size="small"
            loading={loading}
            pagination={false}
            columns={this.columns()}
            dataSource={products}
            bordered
          />
        </Modal>
      </>
    );
  }
}
